<template>
    <!-- Content Header (Page header) -->
    <div class="content-header">
    <div class="container-fluid">
      <div class="row mb-2">
        <div class="col-sm-6">
          <h1 class="m-0">Categorias y Marcas</h1>
        </div><!-- /.col -->
        <div class="col-sm-6">
          <ol class="breadcrumb float-sm-right">
            <li class="breadcrumb-item"><router-link :to="{ name:'dashboard'}">Home</router-link></li>
            <li class="breadcrumb-item active">Categorias - Marcas</li>
          </ol>
        </div><!-- /.col -->
      </div><!-- /.row -->
    </div><!-- /.container-fluid -->
  </div>
  <!-- /.content-header -->

  <div class="row">
    <div class="col-md-6">  
  <div class="card card-secondary card-outline">
      <div class="card-body">
          <div class="row">
              <div class="col-sm-6">
                  <h2><button class="btn btn-primary btn-sm toastrDefaultSuccess" @click="abrirModal('registrar')">Nueva Categoria</button></h2>
              </div>
              <div class="col-sm-6">
                  <div class="input-group">
                      <input type="search" v-model="txtBuscar" @keyup="listarCategorias(1,txtBuscar)" class="form-control form-control-md" placeholder="Buscar categoria">
                      <div class="input-group-append">
                          <button type="submit" class="btn btn-md btn-default">
                              <i class="fa fa-search"></i>
                          </button>
                      </div>
                  </div>
              </div> 
          </div>
          <div class="table-responsive">
              <table class="table table-bordered table-sm table-striped">
                  <thead class="bg-secondary">
                      <tr>
                          <th>Categoria</th>
                          <th>Descripcion</th>
                          <th width="20%">Opciones</th>
                      </tr>
                  </thead>
                  <tbody>
                      <tr v-for="c in categorias" :key="c.id">
                          <td v-text="c.nombre"></td>
                          <td v-text="c.descripcion"></td>
                          <td>
                            
                              <button class="btn btn-sm btn-warning" @click="abrirModal('actualizar', c)"><i class="fas fa-edit"></i></button>&nbsp;
                              <button v-if="c.activo" class="btn btn-sm btn-danger" @click="eliminarCategoria(c.id,c.nombre,c.activo)"><i class="fas fa-trash-alt"></i></button>
                              <button v-else class="btn btn-sm btn-success" @click="eliminarCategoria(c.id,c.nombre,c.activo)"><i class="fas fa-trash-restore-alt"></i></button>&nbsp;
                              <span v-if="c.activo" class="badge badge-success">Habilitad</span>
                            <span v-else class="badge badge-danger">Anulado</span>
                          </td>
                      </tr>
                  </tbody>
              </table>
          </div>
           <!-- Agrega el paginador aquí -->
          <div class="row">
              <div class="col-sm-6">
                  <span>Registros: {{ totalRegistros }}</span>
              </div>
              <div class="col-sm-6">
                  <ul class="pagination pagination-sm justify-content-end">
                      <li class="page-item"  :class="{disabled: isOnFirstPage}">
                          <a class="page-link" @click="goToFirstPage" :disabled="isOnFirstPage">Primero</a>
                      </li>
                      <li class="page-item"  :class="{disabled: isOnFirstPage}">
                          <a class="page-link" @click="goToPreviousPage" >Anterior</a>
                      </li>
                      <li class="page-item" :class="{ active: currentPage === page }" v-for="page in visiblePages" :key="page">
                          <a class="page-link" @click="goToPage(page)">{{ page }}</a>
                      </li>
                      <li class="page-item" :class="{disabled: isOnLastPage}">
                          <a class="page-link" @click="goToNextPage" >Siguiente</a>
                      </li>
                      <li class="page-item" :class="{disabled: isOnLastPage}">
                          <a class="page-link" @click="goToLastPage" :disabled="isOnLastPage">Último</a>
                      </li>
                  </ul>
              </div>
          </div>
      </div>      

  </div><!-- /.Categoria fin -->
</div>
    <!-- Card Marca-->
    <div class="col-md-6">  
  <div class="card card-secondary card-outline">
      <div class="card-body">
          <div class="row">
              <div class="col-sm-6">
                  <h2><button class="btn btn-primary btn-sm toastrDefaultSuccess" @click="abrirModalMarca('registrar')">Nueva Marca</button></h2>
              </div>
              <div class="col-sm-6">
                  <div class="input-group">
                      <input type="search" v-model="txtBuscarMarca" @keyup="listarMarca(1,txtBuscarMarca)" class="form-control form-control-md" placeholder="Buscar Marca">
                      <div class="input-group-append">
                          <button type="submit" class="btn btn-md btn-default">
                              <i class="fa fa-search"></i>
                          </button>
                      </div>
                  </div>
              </div> 
          </div>
          <div class="table-responsive">
              <table class="table table-bordered table-sm table-striped">
                  <thead class="bg-secondary">
                      <tr>
                          <th>Marca</th>
                          <th>Descripcion</th>
                          <th width="20%">Opciones</th>
                      </tr>
                  </thead>
                  <tbody>
                      <tr v-for="m in marcas" :key="m.id">
                          <td v-text="m.nombre"></td>
                          <td v-text="m.descripcion"></td>
                          <td>
                              <button class="btn btn-sm btn-warning" @click="abrirModalMarca('actualizar', m)"><i class="fas fa-edit"></i></button>&nbsp;
                              <button v-if="m.activo" class="btn btn-sm btn-danger" @click="eliminarMarca(m.id,m.nombre,m.activo)"><i class="fas fa-trash-alt"></i></button>
                              <button v-else class="btn btn-sm btn-success" @click="eliminarMarca(m.id,m.nombre,m.activo)"><i class="fas fa-trash-restore-alt"></i></button>&nbsp;
                              <span v-if="m.activo" class="badge badge-success">Habilitad</span>
                            <span v-else class="badge badge-danger">Anulado</span>
                          </td>
                      </tr>
                  </tbody>
              </table>
          </div>
           <!-- Agrega el paginador aquí -->
          <div class="row">
              <div class="col-sm-6">
                  <span>Registros: {{ totalRegistrosMarca }}</span>
              </div>
              <div class="col-sm-6">
                  <ul class="pagination pagination-sm justify-content-end">
                      <li class="page-item"  :class="{disabled: isOnFirstPageMarca}">
                          <a class="page-link" @click="goToFirstPageMarca" :disabled="isOnFirstPageMarca">Primero</a>
                      </li>
                      <li class="page-item"  :class="{disabled: isOnFirstPageMarca}">
                          <a class="page-link" @click="goToPreviousPageMarca" >Anterior</a>
                      </li>
                      <li class="page-item" :class="{ active: currentPageMarca === page }" v-for="page in visiblePagesMarca" :key="page">
                          <a class="page-link" @click="goToPageMarca(page)">{{ page }}</a>
                      </li>
                      <li class="page-item" :class="{disabled: isOnLastPageMarca}">
                          <a class="page-link" @click="goToNextPageMarca" >Siguiente</a>
                      </li>
                      <li class="page-item" :class="{disabled: isOnLastPageMarca}">
                          <a class="page-link" @click="goToLastPageMarca" :disabled="isOnLastPageMarca">Último</a>
                      </li>
                  </ul>
              </div>
          </div>
      </div>      

  </div><!-- /.card Marca-->

    </div>
</div>

  <!--- MODAL CATEGORIA --->
     <div v-if="showModal">
      <div class="modal">
          <div class="modal-overlay"></div>
              <div class="modal-content" v-on:keyup.enter = "tipoAccion==1?registrarCategoria():actualizarCategoria()">
                  <div class="modal-header bg-primary text-white">
                      <h4>{{tituloModal}}</h4>
                      <button type="button" class="close" @click="cerrarModal()">&times;</button>
                  </div>
                  <div class="modal-body">
                      <div class="mb-3 row">
                          <label for="" class="col-sm-3 col-form-label">Nombre: *</label>
                          <div class="col-sm-9">
                              <input type="text" class="form-control" v-model="nombre" placeholder="Nombre de la categoria" style="text-transform:uppercase;">
                          </div>
                      </div>
                      <div class="mb-3 row">
                          <label for="" class="col-sm-3 col-form-label">Descripción:</label>
                          <div class="col-sm-9">
                              <input type="text" class="form-control" v-model="descripcion" placeholder="Descripción de la categoria" style="text-transform:uppercase;">
                          </div>
                      </div>
                  </div>
                  <div class="modal-footer">
                      <button type="button" class="btn btn-secondary" @click="cerrarModal()">Cerrar</button>
                      <button type="button" v-if="tipoAccion==1" class="btn btn-primary" @click="registrarCategoria()">GUARDAR</button>
                      <button type="button" v-if="tipoAccion==2" class="btn btn-primary" @click="actualizarCategoria()">ACTUALIZAR</button>
                  </div>
              </div>
          </div>
          
      </div>
  <!--- FIN MODAL CATEGORIA --->

    <!--- MODAL MARCA --->
    <div v-if="showModalMarca">
        <div class="modal">
            <div class="modal-overlay"></div>
                <div class="modal-content" v-on:keyup.enter = "tipoAccionMarca==1?registrarMarca():actualizarMarca()">
                    <div class="modal-header bg-primary text-white">
                        <h4>{{tituloModalMarca}}</h4>
                        <button type="button" class="close" @click="cerrarModalMarca()">&times;</button>
                    </div>
                    <div class="modal-body">
                        <div class="mb-3 row">
                            <label for="" class="col-sm-3 col-form-label">Nombre: *</label>
                            <div class="col-sm-9">
                                <input type="text" class="form-control" v-model="nombreMarca" placeholder="Nombre de la marca" style="text-transform:uppercase;">
                            </div>
                        </div>
                        <div class="mb-3 row">
                            <label for="" class="col-sm-3 col-form-label">Descripción:</label>
                            <div class="col-sm-9">
                                <input type="text" class="form-control" v-model="descripcionMarca" placeholder="Descripción de la marca" style="text-transform:uppercase;">
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" @click="cerrarModalMarca()">Cerrar</button>
                        <button type="button" v-if="tipoAccionMarca==1" class="btn btn-primary" @click="registrarMarca()">GUARDAR</button>
                        <button type="button" v-if="tipoAccionMarca==2" class="btn btn-primary" @click="actualizarMarca()">ACTUALIZAR</button>
                    </div>
                </div>
            </div>
            
        </div>
    <!--- FIN MODAL MARCA --->
 <!-- Loading Overlay -->
 <div v-if="loading" class="loading-overlay">
    <div class="spinner-border text-light" role="status" style="width: 5rem; height: 5rem;">
    <span class="sr-only">Grabando...</span>
    </div>
    <p class="text-light mt-3">Grabando, espere...</p>
</div>
</template>

<script>
    export default{   
      data(){
          return{
              id:'',
              nombre:'',
              descripcion:'',
              
              idMarca:'',
              nombreMarca:'',
              descripcionMarca:'',

              showModal: false,
              showModalMarca: false,
              tituloModal: '',
              tituloModalMarca: '',
              categorias: [],
              marcas: [],
              errorCategoria:0,
              errorMarca:0,
              arrayMostMsj:[],
              arrayMostMsjMarca:[],
              tipoAccion: 0,
              tipoAccionMarca: 0,
              txtBuscar:'',
              txtBuscarMarca:'',
              errorSaveUpdate:[],
              idEmpresa:'',

              currentPage: 1,
              totalPages: 0,
              listporPage: 15, //debe coincider con pa paginador DRF
              visiblePages: [], // Páginas visibles en el paginado
              totalPagesToShow: 5, // Cantidad de páginas visibles en el paginado
              totalRegistros:0,

              currentPageMarca: 1,
              totalPagesMarca: 0,
              listporPageMarca: 15,
              visiblePagesMarca: [],
              totalPagesToShowMarca: 5,
              totalRegistrosMarca:0,

              loading:false,
          }
      },
      computed: {
          isOnFirstPage() {
          return this.currentPage === 1;
          },
          isOnLastPage() {
          return this.currentPage === this.totalPagesMarca
          },

          isOnFirstPageMarca() {
          return this.currentPageMarca === 1;
          },
          isOnLastPageMarca() {
          return this.currentPageMarca === this.totalPagesMarca
          },
      },
      methods:{
          updateVisiblePages() {
              const halfTotalPagesToShow = Math.floor(this.totalPagesToShow / 2);

              let startPage = Math.max(this.currentPage - halfTotalPagesToShow, 1);
              let endPage = Math.min(this.currentPage + halfTotalPagesToShow, this.totalPages);

              if (this.totalPages > this.totalPagesToShow) {
                  // Si el número de páginas es mayor que el total de páginas a mostrar, ajustamos los extremos
                  if (endPage === this.totalPages) {
                  startPage = Math.max(endPage - this.totalPagesToShow + 1, 1);
                  } else if (startPage === 1) {
                  endPage = Math.min(startPage + this.totalPagesToShow - 1, this.totalPages);
                  }
              }

              this.visiblePages = Array.from({ length: endPage - startPage + 1 }, (_, i) => startPage + i);
          },
          goToPage(pageNumber) {
              // Cambiar la página actual al número de página seleccionado
              this.currentPage = pageNumber;
              // Llamar al método para obtener los datos de la página seleccionada
              this.listarCategorias(pageNumber,'');
          },
          goToPreviousPage() {
              if (this.currentPage > 1) {
                  this.currentPage -= 1;
                  this.listarCategorias(this.currentPage,'');
              }
          },
          goToNextPage() {
              if (this.currentPage < this.totalPages) {
                  this.currentPage += 1;
                  this.listarCategorias(this.currentPage,'');
              }
          },
          goToFirstPage() {
              if (this.currentPage !== 1) {
                  this.currentPage = 1;
                  this.listarCategorias(this.currentPage,'');
              }
          },

          goToLastPage() {
              if (this.currentPage !== this.totalPages) {
                  this.currentPage = this.totalPages;
                  this.listarCategorias(this.currentPage,'');
              }
          },

          updateVisiblePagesMarca() {
              const halfTotalPagesToShow = Math.floor(this.totalPagesToShowMarca / 2);

              let startPage = Math.max(this.currentPageMarca - halfTotalPagesToShow, 1);
              let endPage = Math.min(this.currentPageMarca + halfTotalPagesToShow, this.totalPagesMarca);

              if (this.totalPagesMarca > this.totalPagesToShowMarca) {
                  // Si el número de páginas es mayor que el total de páginas a mostrar, ajustamos los extremos
                  if (endPage === this.totalPagesMarca) {
                  startPage = Math.max(endPage - this.totalPagesToShowMarca + 1, 1);
                  } else if (startPage === 1) {
                  endPage = Math.min(startPage + this.totalPagesToShowMarca - 1, this.totalPagesMarca);
                  }
              }

              this.visiblePagesMarca = Array.from({ length: endPage - startPage + 1 }, (_, i) => startPage + i);
          },
          goToPageMarca(pageNumber) {
              // Cambiar la página actual al número de página seleccionado
              this.currentPageMarca = pageNumber;
              // Llamar al método para obtener los datos de la página seleccionada
              this.listarMarca(pageNumber,'');
          },
          goToPreviousPageMarca() {
              if (this.currentPageMarca > 1) {
                  this.currentPageMarca -= 1;
                  this.listarMarca(this.currentPageMarca,'');
              }
          },
          goToNextPageMarca() {
              if (this.currentPageMarca < this.totalPagesMarca) {
                  this.currentPageMarca += 1;
                  this.listarMarca(this.currentPageMarca,'');
              }
          },
          goToFirstPageMarca() {
              if (this.currentPageMarca !== 1) {
                  this.currentPageMarca = 1;
                  this.listarMarca(this.currentPageMarca,'');
              }
          },

          goToLastPageMarca() {
              if (this.currentPageMarca !== this.totalPagesMarca) {
                  this.currentPageMarca = this.totalPagesMarca
                  this.listarMarca(this.currentPageMarca,'')
              }
          },

          listarCategorias(pageNumber = 1,txtBuscar){
              let me = this
              this.$axios.get(`apinventario/categorias/?page=${pageNumber}&search=${txtBuscar}&idEmpresa=${me.idEmpresa}`)
              .then(function(response){
                  me.categorias = response.data.results
                  me.currentPage = pageNumber
                  me.totalPages = Math.ceil(response.data.count / me.listporPage)
                  me.totalRegistros = response.data.count
                  console.log(me.categorias)
                  me.updateVisiblePages()
              })
          },
          validarCategoria(){
              this.errorCategoria = 0
              this.arrayMostMsj = []
              if(!this.nombre.trim()) this.arrayMostMsj.push("Ingrese el nombre de la Categoria")
              if(this.arrayMostMsj.length) this.errorCategoria = 1
              return this.errorCategoria
          },
          registrarCategoria(){
              if(this.validarCategoria()){
                  this.arrayMostMsj.forEach(element => {
                      this.$toastr.error(element,'Atencion!')
                  });
                  return
              }
              let me = this
              me.loading=true
              this.$axios.post(`apinventario/categorias/`, {
                  nombre: (me.nombre.toUpperCase()).trim(),
                  descripcion: (me.descripcion.toUpperCase()).trim(),
                  idEmpresa: me.idEmpresa,
              })
              .then(function (response) {
                  me.listarCategorias(1,'')
                  me.cerrarModal()
                  console.log(response)
                  me.$toastr.success('Nueva categoria', 'Registrado');
              })
              .catch(function (error) {
                if(error.response && error.response.data){
                    if(error.response.data.nombre){me.errorSaveUpdate.push(error.response.data.nombre[0])}
                }
                if(me.errorSaveUpdate.length > 0){
                    me.errorSaveUpdate.forEach(element => {
                        me.$toastr.error(element,'Error')
                    });
                }
                me.errorSaveUpdate = []          
               })
               .finally(()=>{
                    me.loading = false  // ⬅ ocultar spinner siempre
                })
          },
          actualizarCategoria(){
              if(this.validarCategoria()){
                  this.arrayMostMsj.forEach(element => {
                      this.$toastr.error(element,'Atencion!')
                  });
                  return
              }
              let me = this
              me.loading=true
              this.$axios.patch(`apinventario/categorias/`+me.id+`/`,{
                  nombre: (me.nombre.toUpperCase()).trim(),
                  descripcion: (me.descripcion.toUpperCase()).trim(),
              })
              .then(function(response){
                  console.log(response)
                  me.listarCategorias(me.currentPage,me.txtBuscar)
                  me.cerrarModal()
                  me.$toastr.success('Categoria actualizado', 'Actualizado');
              })
              .catch(function (error) {
                if(error.response && error.response.data){
                    if(error.response.data.nombre){me.errorSaveUpdate.push(error.response.data.nombre[0])}
                }
                if(me.errorSaveUpdate.length > 0){
                    me.errorSaveUpdate.forEach(element => {
                        me.$toastr.error(element,'Error')
                    });
                }
                me.errorSaveUpdate = []          
               })
               .finally(()=>{
                    me.loading = false  // ⬅ ocultar spinner siempre
                })
          },
          eliminarCategoria(id,nombre,activo){
              let me = this
              this.$swal.fire({
              title: nombre,
              text: activo?'Presione Si para eliminar':'Presione Si para restaurar',
              icon: 'warning',
              showCancelButton: true,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: activo? 'Si, eliminar':'Si, restaurar'
              }).then((result) => {
                me.loading=true
              if (result.isConfirmed) {
                  this.$axios.patch(`apinventario/categorias/`+id+`/`,{
                      activo : activo ? 0 : 1,
                  })
                  .then(function(response){
                      console.log(response)
                      me.listarCategorias(me.currentPage,me.txtBuscar)
                      me.cerrarModal()
                      if(activo) me.$toastr.success('Categoria', 'Eliminado')
                      else me.$toastr.success('Categoria', 'Restaurado')
                  })
                  .finally(()=>{
                    me.loading = false  // ⬅ ocultar spinner siempre
                    })
              }
              else{
                me.loading=false
              }
              })
          },
          abrirModal(action, data=[]){
              switch(action){
                  case "registrar":{
                      this.showModal = true
                      this.tituloModal = "NUEVA CATEGORIA"
                      this.tipoAccion = 1
                      break
                  }
                  case "actualizar":{
                      this.showModal = true
                      this.tituloModal = "EDITAR CATEGORIA"
                      this.id = data['id']
                      this.nombre = data['nombre']
                      this.descripcion = data['descripcion']
                      this.tipoAccion = 2
                      break
                  }
              }                
          },
          cerrarModal(){
              this.showModal = false;
              this.id = ''
              this.nombre = ''
              this.descripcion = ''
          },


          listarMarca(pageNumber = 1,txtBuscarMarca){
              let me = this
              this.$axios.get(`apinventario/marcas/?page=${pageNumber}&search=${txtBuscarMarca}&idEmpresa=${me.idEmpresa}`)
              .then(function(response){
                  me.marcas = response.data.results
                  me.currentPageMarca = pageNumber
                  me.totalPagesMarca = Math.ceil(response.data.count / me.listporPageMarca)
                  me.totalRegistrosMarca = response.data.count
                  me.updateVisiblePagesMarca()
              })
          },
          validarMarca(){
              this.errorMarca = 0
              this.arrayMostMsjMarca = []
              if(!this.nombreMarca.trim()) this.arrayMostMsjMarca.push("Ingrese el nombre de la Marca")
              if(this.arrayMostMsjMarca.length) this.errorMarca = 1
              return this.errorMarca
          },
          registrarMarca(){
              if(this.validarMarca()){
                  this.arrayMostMsjMarca.forEach(element => {
                      this.$toastr.error(element,'Atencion!')
                  });
                  return
              }
              let me = this
              me.loading=true
              this.$axios.post(`apinventario/marcas/`, {
                  nombre: (me.nombreMarca.toUpperCase()).trim(),
                  descripcion: (me.descripcionMarca.toUpperCase()).trim(),
                  idEmpresa: me.idEmpresa,
              })
              .then(function (response) {
                  me.listarMarca(1,'')
                  me.cerrarModalMarca()
                  console.log(response)
                  me.$toastr.success('Nueva Marca', 'Registrada');
              })
              .catch(function (error) {
                if(error.response && error.response.data){
                    if(error.response.data.nombre){me.errorSaveUpdate.push(error.response.data.nombre[0])}
                }
                if(me.errorSaveUpdate.length > 0){
                    me.errorSaveUpdate.forEach(element => {
                        me.$toastr.error(element,'Error')
                    });
                }
                me.errorSaveUpdate = []          
               })
               .finally(()=>{
                    me.loading = false  // ⬅ ocultar spinner siempre
                })
          },
          actualizarMarca(){
              if(this.validarMarca()){
                  this.arrayMostMsjMarca.forEach(element => {
                      this.$toastr.error(element,'Atencion!')
                  });
                  return
              }
              let me = this
              me.loading=true
              this.$axios.patch(`apinventario/marcas/`+me.idMarca+`/`,{
                  nombre: (me.nombreMarca.toUpperCase()).trim(),
                  descripcion: (me.descripcionMarca.toUpperCase()).trim(),
              })
              .then(function(response){
                  console.log(response)
                  me.listarMarca(me.currentPage,me.txtBuscarMarca)
                  me.cerrarModalMarca()
                  me.$toastr.success('Marca actualizado', 'Actualizado');
              })
              .catch(function (error) {
                if(error.response && error.response.data){
                    if(error.response.data.nombre){me.errorSaveUpdate.push(error.response.data.nombre[0])}
                }
                if(me.errorSaveUpdate.length > 0){
                    me.errorSaveUpdate.forEach(element => {
                        me.$toastr.error(element,'Error')
                    });
                }
                me.errorSaveUpdate = []          
               })
               .finally(()=>{
                    me.loading = false  // ⬅ ocultar spinner siempre
                })
          },
          eliminarMarca(id,nombre,activo){
              let me = this
              this.$swal.fire({
              title: nombre,
              text: activo?'Presione Si para eliminar':'Presione Si para restaurar',
              icon: 'warning',
              showCancelButton: true,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: activo? 'Si, eliminar':'Si, restaurar'
              }).then((result) => {
                me.loading=true
              if (result.isConfirmed) {
                  this.$axios.patch(`apinventario/marcas/`+id+`/`,{
                      activo : activo ? 0 : 1,
                  })
                  .then(function(response){
                      console.log(response)
                      me.listarMarca(me.currentPage,me.txtBuscar)
                      me.cerrarModalMarca()
                      if(activo) me.$toastr.success('Marca', 'Eliminado')
                      else me.$toastr.success('Marca', 'Restaurado')
                  })
                  .finally(()=>{
                    me.loading = false  // ⬅ ocultar spinner siempre
                })
              }else{
                me.loading=false
              }
              })
          },
          abrirModalMarca(action, data=[]){
              switch(action){
                  case "registrar":{
                      this.showModalMarca = true
                      this.tituloModalMarca = "NUEVA MARCA"
                      this.tipoAccionMarca = 1
                      break
                  }
                  case "actualizar":{
                      this.showModalMarca = true
                      this.tituloModalMarca = "EDITAR CATEGORIA"
                      this.idMarca = data['id']
                      this.nombreMarca = data['nombre']
                      this.descripcionMarca = data['descripcion']
                      this.tipoAccionMarca = 2
                      break
                  }
              }                
          },
          cerrarModalMarca(){
              this.showModalMarca = false;
              this.idMarca = ''
              this.nombreMarca = ''
              this.descripcionMarca = ''
          },
      },
          
      watch: {
          currentPage() {
          // Actualizar las páginas visibles cuando se cambia la página actual
          this.updateVisiblePages();
          },
          totalPages() {
          // Actualizar las páginas visibles cuando se actualiza el número total de páginas
          this.updateVisiblePages();
          },

          currentPageMarca() {
          // Actualizar las páginas visibles cuando se cambia la página actual
          this.updateVisiblePagesMarca();
          },
          totalPagesMarca() {
          // Actualizar las páginas visibles cuando se actualiza el número total de páginas
          this.updateVisiblePagesMarca();
          },
      },
      mounted(){
          this.idEmpresa = localStorage.getItem('idEmpresa')
          this.listarCategorias(1,'')
          this.listarMarca(1,'')
          this.updateVisiblePages()
          this.updateVisiblePagesMarca()
          
      }
  }
</script>

<style scoped>.modal{
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  overflow: auto;
}
.modal-overlay{
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
}
.modal-content{
  width: 40%;
  background-color: white;
  margin-top: 100px;
}
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.6);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 2000;
}
</style>